module.exports = __webpack_public_path__ + "static/media/9DESA20.feb2dc4b.jpg";